import React from 'react';

export default function StatusBadge({ estado, testId = 'status-badge' }) {
  const variants = {
    en_proceso: {
      class: 'bg-[#F59E0B]/20 text-[#F59E0B] border border-[#F59E0B]/30',
      label: 'En Proceso'
    },
    aprobado: {
      class: 'bg-[#10B981]/20 text-[#10B981] border border-[#10B981]/30',
      label: 'Aprobado'
    },
    rechazado: {
      class: 'bg-[#EF4444]/20 text-[#EF4444] border border-[#EF4444]/30',
      label: 'Rechazado'
    },
    rechazado_por_cliente: {
      class: 'bg-[#EF4444]/20 text-[#EF4444] border border-[#EF4444]/30',
      label: 'Rechazado por Cliente'
    }
  };

  const config = variants[estado] || variants.en_proceso;

  return (
    <span 
      className={`px-3 py-1 rounded-full text-xs font-body font-medium ${config.class}`}
      data-testid={testId}
    >
      {config.label}
    </span>
  );
}